module.exports = __webpack_public_path__ + "img/2016-07-06.ecc45c4a.jpg";